import React from "react";

/**
 * Thin horizontal tricolor stripe — uses --flag-1/2/3 CSS variables so it
 * stays in sync with the active country preset. Drop in as a section divider
 * or top/bottom accent.
 *
 * Props:
 *   thickness  – tailwind height class (default 'h-1.5')
 *   className  – extra classes (position, margin, etc.)
 *   reversed   – flip the stripe order
 */
export const FlagStripe = ({ thickness = "h-1.5", className = "", reversed = false }) => {
    const order = reversed ? ["--flag-3", "--flag-2", "--flag-1"] : ["--flag-1", "--flag-2", "--flag-3"];
    return (
        <div
            data-testid="flag-stripe"
            className={`w-full flex ${thickness} ${className}`}
            aria-hidden="true"
        >
            {order.map((v, i) => (
                <div key={i} className="flex-1" style={{ background: `var(${v})` }} />
            ))}
        </div>
    );
};

/**
 * Festive flag bunting — a row of small triangular pennants in the country
 * tricolor. Pure CSS, no images.
 */
export const FlagBunting = ({ count = 14, className = "" }) => {
    const colors = ["var(--flag-1)", "var(--flag-3)", "var(--flag-1)", "var(--flag-3)"]; // skip white for visibility
    return (
        <div
            data-testid="flag-bunting"
            className={`flex items-start justify-between gap-1 ${className}`}
            aria-hidden="true"
        >
            {Array.from({ length: count }).map((_, i) => (
                <div
                    key={i}
                    className="flag-bunting-pennant"
                    style={{
                        background: colors[i % colors.length],
                        animationDelay: `${(i % 5) * 0.15}s`,
                    }}
                />
            ))}
        </div>
    );
};
